import { yupResolver } from "@hookform/resolvers/yup";
import { Button } from "@omni/ui/components/Button/button.component";
import { FormProvider } from "react-hook-form";

import { TextField } from "@/components/Form/RHF/FormFields/TextField/Textfield.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { FormInfoProvider } from "@/utils/forms/formInfo.provider";

import { useOmniForm } from "../Form/RHF/Utils/useOmniForm";
import {
    NewsletterFormValidationSchema,
    NewsletterFormValues
} from "./newsletter.schema";

type Props = {
    buttonText: string;
    helperText: string;
    isBold: boolean;
    alignment: string;
    link: string;
};

const FORM_ID = "newsLetter";

const Newsletter = ({
    buttonText,
    link,
    helperText,
    isBold,
    alignment
}: Props) => {
    const { t } = useGranite();

    const methods = useOmniForm({
        mode: "onBlur",
        reValidateMode: "onBlur",
        defaultValues: {
            email: ""
        },
        resolver: yupResolver(NewsletterFormValidationSchema)
    });

    const onFormSubmit = (form: NewsletterFormValues) => {
        location.assign(`${link}?email=${form.email}`);
    };

    return (
        <div>
            <div
                className={`h5 ${
                    isBold ? "font-weight-bold" : ""
                } ${alignment} mt-0`}
            >
                {helperText}
            </div>
            <FormInfoProvider
                formId={FORM_ID}
                withNeverbounce={true}
            >
                {({ initialized }) => (
                    <FormProvider {...methods}>
                        <form
                            id={FORM_ID}
                            onSubmit={methods.handleSubmit(onFormSubmit)}
                        >
                            <div className={"d-sm-flex"}>
                                <div className={"flex-grow-1 mw-100"}>
                                    <TextField<NewsletterFormValues>
                                        name="email"
                                        label={t("general.form.email.label")}
                                        required
                                        hideLabel={true}
                                        hideMicroCopy={true}
                                        placeholder={t(
                                            "general.form.email.placeholder"
                                        )}
                                        autoComplete={"email"}
                                        disabled={!initialized}
                                    />
                                </div>
                                <div className={"px-sm-3"}>
                                    <Button
                                        data-test="newsletter-button-submit"
                                        className="text-center tw:block"
                                        color="primary"
                                        type={"submit"}
                                        disabled={!initialized}
                                    >
                                        <strong>{buttonText}</strong>
                                    </Button>
                                </div>
                            </div>
                        </form>
                    </FormProvider>
                )}
            </FormInfoProvider>
        </div>
    );
};

export default Newsletter;
